import * as React from "react";
import DashboardAcompParceirosDetalhe from "./detalhe";
import DashboardAcompParceirosTopo from "./topo";

export const DashboardAcompParceirosPage = () => {
  return (
    <React.Fragment>
      <DashboardAcompParceirosTopo />
      <DashboardAcompParceirosDetalhe />
    </React.Fragment>
  );
};